import { render } from "./Services-manufacturers.vue?vue&type=template&id=2d6a64c1&scoped=true"
import script from "./Services-manufacturers.vue?vue&type=script&lang=js"
export * from "./Services-manufacturers.vue?vue&type=script&lang=js"

import "./Services-manufacturers.vue?vue&type=style&index=0&id=2d6a64c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a64c1"]])

export default __exports__